import React, { createContext, Component, useState, useEffect } from 'react';

// export const ContractContext = createContext();
export const BrandingContext = createContext();

export const BrandingProvider = ({ children }) => {
    const [clientId, setClientId] = useState('AIG');
    const [isFetchComplete, setIsFetchComplete] = useState(false);
    // FOR DEVELOPMENT
    // const [clientId, setClientId] = useState('DTC');
    // const [isFetchComplete, setIsFetchComplete] = useState(true)

    const updateClientId = (newId) => {
        setClientId(newId);
    };

    const clientSetup = async () => {
        await fetch('api/helper/getClientByUrl', {
            method: 'get',
            headers: {
                'Content-Type': 'application/json'
            }
        })
            .then((res) => res.json())
            .then((envRes) => {
                const clientId = envRes.clientId.toUpperCase();
                setClientId(clientId);
                setIsFetchComplete(true);
            });
    };

    // SET INITIAL BRAND BY URL
    useEffect(() => {
        clientSetup();
    }, []);

    // BLOCK APP RENDER UNTIL CLIENT ID IS RETURNED
    if (!isFetchComplete) return null;

    return (
        <BrandingContext.Provider
            value={{
                clientId,
                updateClientId
            }}
        >
            {children}
        </BrandingContext.Provider>
    );
};
